export default "__VITE_ASSET__BSPuNTp9__"